import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { queryClient } from '@/lib/queryClient';
import { AuthProvider } from '@/features/auth/AuthProvider';
import { RouteErrorFallback, RoutePending } from '@/features/nav/RouteErrorFallback';
import { routeTree } from './routeTree.gen';
import { applyDensity, readDensity } from '@/features/settings/densityPref';
import './styles/index.css';

applyDensity(readDensity());

const router = createRouter({
  routeTree, context: { queryClient }, defaultPreload: 'intent',
  defaultErrorComponent: RouteErrorFallback, defaultPendingComponent: RoutePending,
});

declare module '@tanstack/react-router' {
  interface Register { router: typeof router }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
